export enum EmperorUIButtonTypes {
  Standard = 'standard',
  // TODO: Remove after m3 full adoption
  Large = 'large',
  Stroked = 'stroked',
  // TODO: Remove after m3 full adoption
  StrokedLarge = 'stroked large',
  FabMini = 'fab mini',
  Fab = 'fab',
  FabExtended = 'fab extended',
  // TODO: Remove after m3 full adoption
  FabLarge = 'fab large',
  // TODO: Remove after m3 full adoption
  Text = 'text',
  // TODO: Remove after m3 full adoption
  Link = 'link',
  // TODO: Remove after m3 full adoption
  InverseStroked = 'inverse stroked',
  // TODO: Remove after m3 full adoption
  Neutral = 'neutral',
  Icon = 'icon',
  Flat = 'flat',
  Basic = 'basic',
  Raised = 'raised',
}

export type MatTooltipPosition =
  | 'above'
  | 'after'
  | 'before'
  | 'below'
  | 'left'
  | 'right';
